import { render, staticRenderFns } from "./OverallUsage.vue?vue&type=template&id=a739e7f2&scoped=true"
import script from "./OverallUsage.vue?vue&type=script&lang=js"
export * from "./OverallUsage.vue?vue&type=script&lang=js"
import style0 from "./OverallUsage.vue?vue&type=style&index=0&id=a739e7f2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a739e7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a739e7f2')) {
      api.createRecord('a739e7f2', component.options)
    } else {
      api.reload('a739e7f2', component.options)
    }
    module.hot.accept("./OverallUsage.vue?vue&type=template&id=a739e7f2&scoped=true", function () {
      api.rerender('a739e7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/TeacherUseData/components/OverallUsage.vue"
export default component.exports